<div class="cf_company">
	<search-bar
		[logoPath]="themeSettings.logoImgSrc"
		[searchOnFilterChange]="false"
		[navigateToResultsOnSearch]="true"
	>
	</search-bar>
	<div class="breadcrumbs-container">
		<breadcrumbs></breadcrumbs>
	</div>
	<div class="content">
		<div
			[ngClass]="{
				'stealthmode-background': true,
				'stealthmode-suppress': suppressStealthMode,
			}"
		></div>
		<div class="majorsection content-header">
			<div class="top-row">
				<div
					[ngClass]="{
					'stealthmode-text': true,
					'stealthmode-suppress':
						suppressStealthMode,
				}"
				>
					{{ stealthLabel }}
				</div>
				<div class="company-logo asset">
					<company-logo [company]="company"></company-logo>
					@if(isNew && featureSwitches.enableShowCompanyLogos){
					<div class="new-company-indicator">
						{{ newLabel }}
					</div>
					}
				</div>
				<div class="action-wrapper">
					@if(isFollowEnabled && isInternalView){
					<div class="follow-section">
						<div
							class="follow-button"
							[ngClass]="{
							'is-following': isFollowing,
							'is-stealthmode': !suppressStealthMode,
						}"
							(click)="setFollowing(!isFollowing)"
						>
							<div class="header-button-label">
								{{ followLabel }}
								{{ companyLabel }}
							</div>
							<div class="icon"></div>
						</div>
					</div>
					}
				</div>
			</div>
			<div class="grp2">
				<div class="name-supertext">{{ assetLabel }}:</div>
				<h1 class="name-label">
					{{ asset.name }}
				</h1>
				<div class="stage-info header-item">
					<div class="title">
						{{ developmentStageLabel }}
					</div>
					<div class="development-stage">
						{{ asset.developmentStage }}
					</div>
				</div>
				<div class="therapeutic-areas header-item">
					<div class="title">{{ therapeuticAreaLabel }}</div>
					<tags
						class="grp2-tags"
						[useWhiteBackground]="true"
						[marginTopForWrapping]="22"
						[targetIdentifier]="asset.name"
						[allowEliding]="false"
						[tags]="asset.therapeuticArea"
					>
					</tags>
				</div>
			</div>
			<div class="grp1">
				<h1 class="name-label clickable" (click)="navigateToCompany()">
					{{ company.name }}
					<company-status-icon
						[statuses]="company.statuses"
						float="right"
						tooltipTop="32px"
						tooltipLeft="188px"
					></company-status-icon>
				</h1>
				@if(validCompanyWebsiteUrl){
				<div class="url">
					<a href="{{ validCompanyWebsiteUrl }}" target="_blank">{{
						company.website
					}}</a>
				</div>
				}
			</div>
		</div>
		<div class="details">
			<div class="title">{{ assetDetailsTitle }}</div>
			<table>
				@for(prop of AssetKeys; track prop) {
				<tr>
					<th class="header">
						{{ getHeaderText(prop) }}
					</th>
					<td>
						{{ getValue(prop) }}
					</td>
				</tr>
				}
			</table>
			@if(asset.deliverablePartners?.length > 0) {
			<div class="title">{{ deliverablePartnersTitle }}</div>
			<table>
				<tr>
					<th>Name</th>
					<th>Role</th>
				</tr>
				@for(partner of asset.deliverablePartners; track
				partner.partnerId) {
				<tr>
					<td class="header">
						{{ partner.partnerName }}
					</td>
					<td>
						{{ partner.role }}
					</td>
				</tr>
				}
			</table>
			}
		</div>
	</div>
</div>
